import React from "react";

import login from "../landingImgs/login1 - Copy.png";
import home from "../landingImgs/home1.png";
import wallet from "../landingImgs/wallet1.png";
import notification from "../landingImgs/notification.png";

import { useMediaQuery } from "react-responsive";
import AuctionFeatureLogo from "../children/AuctionFeatureLogo";

function WorkPage() {
  const isDastop = useMediaQuery({ query: "(max-width: 1600px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1500px)" });
  const isSmallLaptop = useMediaQuery({ query: "(max-width: 1200px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 900px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 650px)" });
  return (
    <div >
      <AuctionFeatureLogo
        headers={"Create an account and verify your details"}
        images={login}
      />
      <AuctionFeatureLogo
        headers={"Explore available auctions and detailed catalogs."}
        images={home}
        order={2}
      />
      <AuctionFeatureLogo
        headers={"Use the Cercle X Wallet for seamless payments."}
        images={wallet}
      />
      <div
        className={`valign-wrapper justify-center gap-5 mt-5 ${
          isMobile && "column textAlign-center "
        }`}
      >
        <h1
          data-aos="fade-right"
          className="cercle-purple-text"
          style={{
            width: isLaptop ? "" : isDastop ? "600px" : "768px",
            fontSize: isSmallLaptop ? "25px" : isLaptop ? "35px" : "40px",
            lineHeight: isTablet ? "30px" : "55px",
          }}
        >
          Receive real-time notifications about auction status.
        </h1>
        <img
          className="responsive-img"
          data-aos="flip-up"
          src={notification}
          alt="login-logo"
        />
      </div>
    </div>
  );
}

export default WorkPage;
